module.exports = __webpack_public_path__ + "docs/assets/fonts/OxygenMono-Regular-54a83c6fb676ac444dabd08b24861e97.ttf";